import {SweepValueDropdownDocument} from '../../generated/graphql';
import type * as FilterTypes from '../../util/filterTypes';
import type * as RunTypes from '../../util/runTypes';
import {FilterSimpleValueDropdownComponents} from '../InfiniteScrollDropdown/FilterSimpleValueComponents';
import {makeInfiniteDropdown} from '../InfiniteScrollDropdown/InfiniteDropdown';

export function isSweepFilterKey(
  filter: FilterTypes.IndividualFilter<RunTypes.Key>
): boolean {
  return (
    filter.key.section === 'run' &&
    (filter.key.name === 'sweep' || filter.key.name === 'sweepName')
  );
}

/**
 * Value selector backed by `project.sweeps` (rather than
 * `project.runFieldValues`).
 *
 * The runFieldValues source can only surface sweep names that already
 * have at least one non-internal run, so a freshly-registered sweep is
 * invisible until the first agent run lands. `project.sweeps` reads
 * from the sweeps table directly, so a sweep is pickable the moment
 * it's created. Selector code branches on `isSweepFilterKey(filter)`
 * to choose between this dropdown and the generic
 * `FilterSimpleValueInfiniteDropdown`.
 */
export const SweepValueInfiniteDropdown = makeInfiniteDropdown(
  FilterSimpleValueDropdownComponents,
  {
    extractItems: (data: any): string[] => {
      const edges = data?.project?.sweeps?.edges;
      if (edges == null) {
        return [];
      }
      const out: string[] = [];
      for (const edge of edges) {
        const name = edge?.node?.name;
        if (typeof name === 'string' && name !== '') {
          out.push(JSON.stringify(name));
        }
      }
      return out;
    },
    extractPageInfo: (data: any) => {
      return data?.project?.sweeps?.pageInfo ?? {};
    },
    query: SweepValueDropdownDocument,
    buildSearchVariables: (searchString: string) => ({
      filters:
        searchString === ''
          ? null
          : JSON.stringify({name: {$contains: searchString}}),
      order: '-createdAt',
    }),
  }
);
